<div class="batch">
    <p class="batch-name"><span *ngIf="params.data.batchsId">{{params.data?.batchName}}</span></p>
</div>